import { parseEther } from 'ethers/lib/utils';
import Spinner from '../../components/Spinner';
import PoolState from '../../context/pool/PoolState';
import useLiquidityPools from '../../hooks/web3/pools/useLiquidityPools';
// import useUserTotalDeposits from '../../hooks/web3/pools/useUserTotalDeposits';
import useMockUserTotalDeposits from '../../hooks/web3/pools/useMockUserTotalDeposits';
import PoolChart from './PoolChart';
import PoolHistoricalPnl from './PoolHistoricalPnl';
import PoolLockedDeposits from './PoolLockedDeposits';
import PoolOverviewContainer from './PoolOverviewContainer';
import PoolSelector from './PoolSelector';
import PoolTotalDeposits from './PoolTotalDeposits';
import PoolTotalWithdraws from './PoolTotalWithdraws';
import Card from '../../components/Card';
import { useWeb3React } from '@web3-react/core';

const Pools = () => {
    const { account } = useWeb3React();

    const { isLoading } = useLiquidityPools();

    // const { userTotalDeposits } = useUserTotalDeposits();
    const { userTotalDeposits } = useMockUserTotalDeposits();

    return (
        <PoolState>
            <section id='pools'>
                <div className='container'>
                    {isLoading ? (
                        <div className='loading-container'>
                            <Spinner />
                            <span>Loading liquidity pools...</span>
                        </div>
                    ) : (
                        <>
                            <PoolSelector />
                            <PoolOverviewContainer />
                            <PoolChart />
                            {account ? (
                                userTotalDeposits &&
                                !parseEther(
                                    userTotalDeposits.totalDepositAssetAllPools
                                ).isZero() ? (
                                    <>
                                        <PoolLockedDeposits />
                                        <PoolTotalDeposits />
                                        <PoolTotalWithdraws />
                                        <PoolHistoricalPnl />
                                    </>
                                ) : (
                                    <Card className='no-positions'>
                                        You have no pool positions yet
                                    </Card>
                                )
                            ) : (
                                <Card className='not-connected'>
                                    Connect your wallet to see your pool positions
                                </Card>
                            )}
                        </>
                    )}
                </div>
            </section>
        </PoolState>
    );
};

export default Pools;
